export default "__VITE_ASSET__9aK3S1wB__"